import type { IAuth, IHeaders } from '@belong/types';
import { HEADERS } from '@belong/constants';
import { getAuthCookie } from '@belong/cookies';
import { getCorrelationId } from '@belong/user';

export const getSessionInfo = (headers?: IHeaders): IAuth => {
  const {
    [HEADERS.CORRELATION_ID]: correlationId,
    [HEADERS.ACCESS_TOKEN]: accessToken,
    [HEADERS.ID_TOKEN]: idToken
  } = headers || {};
  const cookie = getAuthCookie();

  return {
    accessToken: accessToken || cookie.accessToken || '',
    clientId: cookie.clientId,
    correlationId: correlationId || getCorrelationId(),
    expiresIn: cookie.expiresIn,
    idToken: idToken || cookie?.idToken || '',
    tokenType: cookie.tokenType
  };
};
